import { FC } from 'react';
import { StackHeaderProps } from '@react-navigation/stack';
import { headerFactory } from '../../../components';
import { SwapHeaderTitle } from './SwapHeaderTitle';

export const SwapHeader: FC<StackHeaderProps & { hasRightContent?: boolean; rightContent?: FC }> = (
  props: StackHeaderProps & { hasRightContent?: boolean; rightContent?: FC },
) => headerFactory(props, SwapHeaderTitle);
